import { all } from "redux-saga/effects";
import { watcher } from "./employeeVerificationSaga";

export default function* employeeVerificationSaga(action) {
    yield all([
        watcher(action)
    ]);
}
